/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";

//custom libraries
import { ORG_GET_BY_ORGID, METHOD, GET_ORGS } from "../../constants/requests";
import { LIMIT } from "../../constants/common";
import { useSelectedStoreValue } from "../../context";
import { useRestService } from "./use-rest-service";

export const useOrganizationHandler = () => {
  const { executeV2Request } = useRestService();

  const { selectedStore } = useSelectedStoreValue();

  const getOrgInfoById = (orgId: any) => {
    const requestOptions: AxiosRequestConfig = {
      method: METHOD.GET,
      url: ORG_GET_BY_ORGID.replace("{orgid}", orgId),
    };

    return executeV2Request(requestOptions);
  };

  const getOrgs = (parameters: any) => {
    if (!parameters.offset) {
      parameters.offset = 0;
    }
    const newParams = {
      ...parameters,
      limit: String(LIMIT),
      taskName: "CreateRegisteredCustomer",
      storeId: selectedStore.id,
    };
    const requestOptions: AxiosRequestConfig = {
      params: newParams,
      method: METHOD.GET,
      url: GET_ORGS,
    };

    return executeV2Request(requestOptions);
  };

  return {
    getOrgInfoById,
    getOrgs,
  };
};
